import { AccessSegment, ColumnAccess } from "./types";

// // // //

const ACCESS_SEGMENT_RANK: Record<AccessSegment, number> = {
    [AccessSegment.Free]: 0,
    [AccessSegment.Preview]: 1,
    [AccessSegment.Pro]: 2,
    [AccessSegment.Enterprise]: 3,
};

/**
 * Whether the segment is at or above the required segment
 */
export function meetsAccessSegment(
    segment: AccessSegment,
    required: AccessSegment = AccessSegment.Free,
): boolean {
    return ACCESS_SEGMENT_RANK[segment] >= ACCESS_SEGMENT_RANK[required];
}

/**
 * The segment required to sort on a column - `sort` defaults to `view`, and is never lower than `view`
 */
export function getSortAccessSegment(
    access: ColumnAccess | undefined,
): AccessSegment {
    const view = access?.view ?? AccessSegment.Free;
    const sort = access?.sort ?? view;
    return meetsAccessSegment(sort, view) ? sort : view;
}

export enum AccessGate {
    Login = "login",
    Upgrade = "upgrade",
}

/**
 * What's blocking the segment from the required segment - null when it isn't blocked
 * NOTE - only logged-out viewers fall below Preview, so a Preview requirement means logging in
 */
export function getAccessGate(
    segment: AccessSegment,
    required: AccessSegment = AccessSegment.Free,
): AccessGate | null {
    if (meetsAccessSegment(segment, required)) {
        return null;
    }
    return required === AccessSegment.Preview
        ? AccessGate.Login
        : AccessGate.Upgrade;
}

/**
 * Whether the segment can see a column's values
 */
export function canViewColumn(
    segment: AccessSegment,
    access: ColumnAccess | undefined,
): boolean {
    return meetsAccessSegment(segment, access?.view);
}

/**
 * Whether the segment can sort on a column
 */
export function canSortColumn(
    segment: AccessSegment,
    access: ColumnAccess | undefined,
): boolean {
    return meetsAccessSegment(segment, getSortAccessSegment(access));
}
